import { Injectable, inject, signal } from '@angular/core';
import { HelperDebugLoggerControllerService } from './helper-debug-logger-controller.service';

@Injectable({
  providedIn: 'root',
})
export class HelperNetworkSyncControllerService {
  private debugLogger = inject(HelperDebugLoggerControllerService);

  public readonly isOnline = signal<boolean>(typeof navigator !== 'undefined' ? navigator.onLine : true);
  public readonly connectionType = signal<'wifi' | 'cellular' | 'offline' | 'unknown'>('wifi');
  public readonly isInitialized = signal<boolean>(false);

  constructor() {
    this.init();
  }

  /**
   * Initializes network status listeners
   */
  public init(): void {
    if (this.isInitialized()) {
      return;
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('online', () => {
        this.isOnline.set(true);
        this.updateConnectionType();
        this.debugLogger.addLog('info', '[NETWORK] Device came ONLINE.');
      });

      window.addEventListener('offline', () => {
        this.isOnline.set(false);
        this.connectionType.set('offline');
        this.debugLogger.addLog('info', '[NETWORK] Device went OFFLINE.');
      });
    }

    this.updateConnectionType();
    this.isInitialized.set(true);
  }

  private updateConnectionType(): void {
    if (typeof navigator === 'undefined' || !navigator.onLine) {
      this.connectionType.set('offline');
      return;
    }

    const conn = (navigator as any).connection;
    if (conn && conn.type) {
      if (conn.type === 'wifi') {
        this.connectionType.set('wifi');
      } else if (conn.type === 'cellular') {
        this.connectionType.set('cellular');
      } else {
        this.connectionType.set('unknown');
      }
    } else {
      this.connectionType.set('wifi');
    }
  }
}
